module.exports = __webpack_public_path__ + "img/index_szjc.1d3c7780.svg";